import { Link, useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import { fetchCustomerDetail } from '#/api/crmMgmt/customer/fetchDetail';
import { fetchSnProductMappingDetail } from '#/api/aftersalesMgmt/snProductMapping/fetchDetail';
import { ROUTES } from '#/config/routes';
import { cn } from '#/lib/utils';
import { Button } from '#/modules/commonComponents/button';
import SnProductMappingCommandBar from '#/modules/crmMgmt/aftersales/snProductMapping/components/SnProductMappingCommandBar';
import SnProductMappingDetailSection from '#/modules/crmMgmt/aftersales/snProductMapping/components/SnProductMappingDetailSection';
import SnProductMappingInspectionKindsCard from '#/modules/crmMgmt/aftersales/snProductMapping/components/SnProductMappingInspectionKindsCard';
import {
  getSnProductMappingApiErrorMessage,
} from '#/modules/crmMgmt/aftersales/snProductMapping/helper/apiError';
import PageShell from '#/modules/infra/layout/PageShell';
import { customerDetailQueryKey, snProductMappingDetailQueryKey } from '#/utils/queryKeys';

const SnProductMappingDetailPage = () => {
  const { id } = useParams();

  const detailQuery = useQuery({
    queryKey: snProductMappingDetailQueryKey(id),
    queryFn: () => fetchSnProductMappingDetail(id),
    enabled: Boolean(id),
    retry: false,
  });

  const detail = detailQuery.data?.data;

  const customerQuery = useQuery({
    queryKey: customerDetailQueryKey(detail?.customerId),
    queryFn: () => fetchCustomerDetail(detail.customerId),
    enabled: Boolean(detail?.customerId),
    retry: false,
  });

  return (
    <PageShell variant="detail">
      <div className="layout-shell__body">
        <div className="mx-auto w-full max-w-4xl space-y-4">
          <div
            className={cn(
              'sticky top-0 z-20 -mx-1 flex flex-wrap items-center gap-2',
              'border-b border-slate-200 bg-canvas px-1 pb-3 pt-1',
            )}
          >
            <h1 className="page_title mb-0!">
              <span className="border-l-5 border-primary-400 pl-2.5">物料序號詳情</span>
            </h1>
            <Button type="button" variant="outline" asChild>
              <Link to={ROUTES.snProductMapping}>返回列表</Link>
            </Button>
          </div>

          {detailQuery.isLoading ? (
            <p className="text-sm text-muted-foreground">載入中…</p>
          ) : null}

          {detailQuery.isError ? (
            <p className="text-sm text-destructive">
              {getSnProductMappingApiErrorMessage(detailQuery.error, '載入 物料序號失敗')}
            </p>
          ) : null}

          {detail ? (
            <>
              <SnProductMappingDetailSection
                detail={detail}
                customer={customerQuery.data?.data}
                customerLoading={customerQuery.isLoading}
                actions={(
                  <SnProductMappingCommandBar
                    detail={detail}
                    onRefetch={() => detailQuery.refetch()}
                  />
                )}
              />
              <SnProductMappingInspectionKindsCard
                mappingId={String(id)}
                onDetailRefetch={() => detailQuery.refetch()}
              />
            </>
          ) : null}
        </div>
      </div>
    </PageShell>
  );
};

export default SnProductMappingDetailPage;
